<template>
  <circle-statistic
    icon="add_shopping_cart"
    :title="$t('customs.dashboard.totalSoldProducts')"
    :sub-title="subtitle"
    :value="periodDiffPositiveValue"
    :text="totalSoldProducts.toString(10)"
    :color="color"
    :caption="periodDiffIsInfinity ? '' : $t('customs.dashboard.previousPeriod') + ' ' + totalSoldProductsPrevious"
    :is-negative="Math.sign(percentagePeriodDiff) !== 1"
    :loading="loading"
  >
  </circle-statistic>
</template>

<script>
  import CircleStatistic from '@/components/Widgets/statistic/CircleStatistic'
  export default {
    name: 'TotalSoldProductsIndicator',
    components: {
      CircleStatistic
    },
    props: {
      sales: Array,
      previousSales: Array,
      loading: Boolean,
      totalSoldProducts: Number,
      totalSoldProductsPrevious: Number
    },
    computed: {
      percentagePeriodDiff() {
        let diff = ((this.totalSoldProducts - this.totalSoldProductsPrevious) / this.totalSoldProductsPrevious) * 100
        if (!isNaN(diff)) {
          return Math.round(diff)
        } else {
          return 0
        }
      },
      periodDiffPositiveValue() {
        let diff = this.percentagePeriodDiff
        if (diff < 0) {
          return -diff
        } else {
          return diff
        }
      },
      subtitle() {
        return this.percentagePeriodDiff === Infinity
          ? this.$t('customs.dashboard.unavailableDataForPreviousPeriod')
          : this.percentagePeriodDiff + '% ' + this.$t('customs.dashboard.vsPreviousPeriod')
      },
      periodDiffIsInfinity() {
        return this.percentagePeriodDiff === Infinity
      },
      color() {
        if (Math.sign(this.percentagePeriodDiff) === 1) {
          return 'green'
        } else if (Math.sign(this.percentagePeriodDiff) === -1) {
          return 'red'
        } else {
          return 'primary'
        }
      }
    }
  }
</script>

<style scoped></style>
